module.exports = __webpack_public_path__ + "media/bootstrap-icons/volume-mute-fill-97a03ab1.svg";